import { render } from "./AddMerchant.vue?vue&type=template&id=75918f7c&ts=true"
import script from "./AddMerchant.vue?vue&type=script&lang=ts"
export * from "./AddMerchant.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__